import React from 'react';
import cn from 'classnames';
import { string, func, oneOfType } from 'prop-types';

const propTypes = {
  type: string.isRequired,
  tag: oneOfType([string, func]),
};

const defaultProps = {
  tag: 'i',
};

const Icon = ({ type, className, tag: Tag, ...rest }) => (
  <Tag className={cn(`icon-${type}`, className)} aria-hidden="true" {...rest} />
);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;
